import React, { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { FormError, StyledLabel } from 'components/organisms/FormsSlice/Forms/Forms';
import { TextInputProps } from './TextInput.types';
import { StyledFieldDescription, StyledInputText, WrapperText } from './TextInput.styles';

export const TextInput: React.FC<TextInputProps> = ({
  defaultValue,
  errorMessagePattern,
  errorMessageRequired,
  fieldDescription,
  hasError,
  label,
  name,
  placeholder,
  register,
  validationOptions,
  type = 'text',
}) => {
  const { t } = useTranslation('common');
  const isLabelNotEmpty = label?.length > 0 ? true : false;

  const [warningMessage, setWarningMessage] = useState('');

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    if (name === 'phone' || name === 'mobilePhone') {
      const oldValue = input.value;
      input.value = input.value.replace(/[^0-9+\s()\-]/g, '');

      if (oldValue !== input.value) {
        setWarningMessage(t('contactForm.errors.onlyNumbers'));
      } else {
        setWarningMessage('');
      }
    }
  };

  return (
    <>
      {isLabelNotEmpty && <StyledLabel htmlFor={name}>{t(label)}</StyledLabel>}

      {!fieldDescription && (
        <StyledInputText
          defaultValue={defaultValue}
          type={type}
          hasError={hasError}
          id={name}
          placeholder={t(placeholder)}
          {...register(name, validationOptions)}
          onInput={handleInput}
        />
      )}

      {fieldDescription && (
        <WrapperText>
          <StyledInputText
            defaultValue={defaultValue}
            type={type}
            hasError={hasError}
            id={name}
            placeholder={t(placeholder)}
            {...register(name, validationOptions)}
            onInput={handleInput}
          />
          <StyledFieldDescription>{t(fieldDescription)}</StyledFieldDescription>
        </WrapperText>
      )}

      {warningMessage && <FormError>{warningMessage}</FormError>}

      {hasError && errorMessagePattern && <FormError>{t(errorMessagePattern)}</FormError>}
      {hasError && errorMessageRequired && <FormError>{t(errorMessageRequired)}</FormError>}
    </>
  );
};
